module.exports = __webpack_public_path__ + "img/wifi-1.9d1e4f73.png";